import moment from 'moment';

// Map between i18n language codes and moment.js locales
export const momentLocaleMap = {
    en: 'en-gb',
    fr: 'fr',
    es: 'es',
    de: 'de',
    pt: 'pt',
    ja: 'ja',
    zh: 'zh-cn',
    cn: 'zh-cn',
    hy: 'hy-am'
};

// Map between i18n language codes and Ant Design locales
export const antdLocaleMap = {
    en: () => import('antd/es/locale/en_US'),
    fr: () => import('antd/es/locale/fr_FR'),
    es: () => import('antd/es/locale/es_ES'),
    de: () => import('antd/es/locale/de_DE'),
    pt: () => import('antd/es/locale/pt_PT'),
    ja: () => import('antd/es/locale/ja_JP'),
    zh: () => import('antd/es/locale/zh_CN'),
    cn: () => import('antd/es/locale/zh_CN'),
    hy: () => import('antd/es/locale/hy_AM')
};

// Initialize moment locale
export const initializeMomentLocale = async (language) => {
    const momentLang = momentLocaleMap[language] || 'en-gb';
    try {
        await import(`moment/locale/${momentLang}`);
        moment.locale(momentLang);
    } catch (err) {
        console.warn(`Moment locale import failed for: ${momentLang}`, err);
        moment.locale('en-gb');
    }
};

// Get Ant Design locale
export const getAntdLocale = async (language) => {
    try {
        const localeImport = antdLocaleMap[language] || antdLocaleMap.en;
        const module = await localeImport();
        return module.default;
    } catch (err) {
        console.warn(`Antd locale import failed for: ${language}`, err);
        const module = await antdLocaleMap.en();
        return module.default;
    }
};